import React, { Component } from "react";

import styles from "./styles.scss";
import * as router from "react-router-redux";
import { connect } from "react-redux";
import { actions } from "./redux";
import { Button, Card, CardContent, Grid, Select, MenuItem, CardHeader, CircularProgress } from "@material-ui/core";
import { ArrowDropDown, ArrowDropUp } from "@material-ui/icons";
import Highcharts from "highcharts";
import ReactHighcharts from "react-highcharts";
import CSSModules from "react-css-modules";
import { Interval, Point, PointDisplay } from "../../../services/Live/types";
import { DateTime } from "../../../utils";
import SearchBar from "../../../components/SearchBar/SearchBar";
import Graph from "../../../components/OutcomeGraph/OutcomeGraph";
import moment from "moment";
import { DateRangePicker } from "../../../libs/react-date-range";
import { actions as timeaction } from "../../../redux/timeRedux";

import diagnosticIcon from "../../../assets/Icons/diagnostic_rule-01.png";
import learnedIcon from "../../../assets/Icons/learned_rule-01.png";
import verificationIcon from "../../../assets/Icons/verification_rule-01.png";
import failedIcon from "../../../assets/Icons/failed-01.png";

@CSSModules(styles, { allowMultiple: true })
class Rules extends Component {

   componentWillMount() {
         var test = false;

         if(this.props.map === undefined || this.props.map === null) {
            test = true;
         }

         if(this.props.currentSite === undefined || this.props.currentSite === null || this.props.currentSite.name !== this.props.loadedSite) {
            test = true;
         }

         if(test === true) {
            this.props.getRuleCategories(this.props.match.params.name);
         }

//         if(!this.props.map || (this.props.currentSite && this.props.loadedSite !== this.props.currentSite.name) /*|| this.props.loadedTime !== this.props.time*/) {
//            this.props.getRuleCategories(this.props.match.params.name);
//         }
   }

   convertToMins(time) {
      return moment.duration(moment(time.endDate).diff(time.startDate)).asMinutes();
   }

   changeTime(result) {
		const range = result.selection || result.range1;
      range.endDate = DateTime.endOf("day", range.endDate);
      this.props.changeTime(range);
   }

   shouldComponentUpdate(nextProps) {
      const props = this.props;
      for (var p in nextProps) {
         if (nextProps.hasOwnProperty(p)) {
            if (nextProps[p] !== props[p]) {
               return true;
            }
         }
      }
      // pos MUI Select rerenders the component like 10 times without changing anything. laggy af
      return false;
   }

   getIcon(rule) {
      switch (rule.ruleModeCode) {
         case "RMVerification":
            return <img styleName="icon" src={verificationIcon} />;
         case "RMLearned":
            return <img styleName="icon" src={learnedIcon} />;
         case "RMDiagnostic":
            return <img styleName="icon" src={diagnosticIcon} />;
         default:
            return null;
      }
   }

   closeCalendar() {
      this.props.toggleCalendar();
   }

   sameDay(d1, d2) {
      return d1 && d2 && d1.getFullYear() === d2.getFullYear() &&
            d1.getMonth() === d2.getMonth() &&
            d1.getDate() === d2.getDate();
   }

   renderCategory(node, level) {
      let elements = [];

      if(!node) {
            return;
      }

      if(node._children.length > 0) {
            node._children.forEach((child, index) => {
                  elements.push(
                        <React.Fragment key={index}>
                              <Grid
                                    container
                                    xs={12}
                                    item
                                    open={child._isOpen}
                                    firstitem={(index === 0).toString()}
                                    lastitem={(index === node._children.length - 1).toString()}
                                    styleName="row toprowselectable"
                                    style={{paddingLeft: 50 * level}}
                                    onClick={() => {
                                          if (!child._isOpen && child.numRules > 0 && child.hasRules) {
                                                this.props.getRulesInstsForRule(child);
                                          }
                                          this.props.toggleOpenCategory(child);
                                    }}>
                                    <Grid xs={level === 0 ? 2 : 8} md={level === 0 ? 2 : 8} item style={{marginRight: -((50 * level) / 4)}}>
                                          <div styleName="name">{child.title}</div>
                                    </Grid>
                                    {
                                          level === 0 &&
                                          <Grid xs={6} md={6} item>
                                                <div styleName="nameAlt">{child.displayDescription}</div>
                                          </Grid>
                                    }
                                    <Grid xs={2} md={2} item styleName="centertext" style={{marginRight: 8 * level}}>
                                          <div styleName="rulecount center" open={child._isOpen}>
                                                {child.numRules}
                                          </div>
                                    </Grid>
                                    <Grid
                                          xs={2}
                                          md={2}
                                          item
                                          styleName="center failed-text"
                                          didfail={(child.failedRules > 0).toString()}
                                    >
                                          {child.failedRules}
                                    </Grid>
                              </Grid>
                              {
                                    child._isOpen &&
                                    this.renderCategory(child, level + 1)
                              }
                        </React.Fragment>
                  )
            });
      }

      if(node.rules !== undefined && node.rules !== null && node.rules.length > 0) {
            node.rules.forEach((rule, index) => {
                  elements.push(
                        <React.Fragment key={index}>
                              <Grid
                                    key={index}
                                    container
                                    item
                                    open={rule._isOpen}
                                    styleName="row ruleinst"
                                    first={(index === 0).toString()}
                                    last={(index === node.rules.length - 1).toString()}
                                    onClick={() =>
                                    this.props.navigate("/Reports/" + rule.ruleInstanceId + "/" + index + "/" + node.rules.map(rule => {
                                          return rule.ruleInstanceId;
                                    }), {time: this.props.time})
                                    }
                              >
                                    <Grid
                                    item
                                    styleName="subrow"
                                    style={{paddingLeft: 50 * level, position: "relative"}}
                                    colSpan="3"
                                    container
                                    direction="row"
                                    onMouseEnter={() => this.mouseEnter(rule)}
                                    onMouseLeave={() => this.mouseLeave(rule)}
                                    >
                                          <div styleName="name showtab fl1">
                                                {rule.hasFailingOutcome && (
                                                <img src={failedIcon} styleName="icon" />
                                                )}
                                                <div
                                                style={{ marginLeft: rule.hasFailingOutcome ? 0 : 37 }}
                                                >
                                                {rule.name}
                                                {
                                                      rule.enabled !== true &&
                                                      <span style={{fontSize: 12, color: "#999", marginLeft: 4}}>(Disabled)</span>
                                                }
                                                </div>
                                          </div>
                                          {
                                                !rule.outcomes &&
                                                <div styleName="fl1" style={{flexDirection: "row",display: "flex"}}>
                                                      <div styleName="fl1 center failed-text">
                                                            &nbsp;
                                                      </div>
                                                      <div styleName="fl1 center failed-text" didfail="true" >
                                                            {rule.failingOutcomeTotal}
                                                      </div>
                                                </div>
                                          }
                                          {
                                                rule.outcomes &&
                                                <Graph
                                                      containerClass="graph"
                                                      classes={styles}
                                                      totalTimeSpanMins={this.convertToMins(this.props.time)}
                                                      fromTime={DateTime.toISOstring(
                                                      this.props.time.startDate
                                                      )}
                                                      data={rule.outcomes}
                                                />
                                          }
                                          {
                                                rule.isGettingOutcome &&
                                                <div id={`${rule.ruleInstanceId}OutcomesGet`} styleName="outcomesGet" style={{position:"absolute",top:0,left:"50%",right:0,bottom:0,flex:1,display:"flex"}}>
                                                
                                                </div>
                                          }
                                    </Grid>
                              </Grid>
                        </React.Fragment>
                  )
            });
      }


      return (
            <React.Fragment>
                  {
                        elements
                  }
            </React.Fragment>
      )
   }

   mouseEnter(rule) {
      if(rule.outcomes) {
            return;
      }

      rule.isGettingOutcome = true;
      let timeoutId = setTimeout(function(){
            this.getOutcomes(rule);
            rule.isGettingOutcome = false;
      }.bind(this), 1000)
      this.props.setTimeout(timeoutId);
   }

   getOutcomes(rule) {
      this.props.clearTimeout();
      this.props.getOutcomesForRuleInst(rule);
   }

   mouseLeave(rule) {
      if(this.props.timeoutId) {
            window.clearTimeout(this.props.timeoutId);
            this.props.clearTimeout();
            rule.isGettingOutcome = false;
      }
   }

   renderCategories(rootNode) {
      return this.renderCategory(rootNode, 0);
   }

   render() {
      return (
         <div styleName="outer">
            {/* click area to close calender */}
            {this.props.calendarOpen && <div onClick={() => this.props.toggleCalendar()} styleName="toggle-area" />}
            <div styleName="header">

                  <div style={{display: "flex", flexDirection: "row", flexWrap: "wrap"}}>
                        <SearchBar
                              timeout={500}
                              searchBarId={"rules/List"}
                              style={{
                                    backgroundColor: "transparent",
                                    minHeight: 30,
                                    height: 60,
                                    marginLeft: 15,
                                    marginRight: 15,
                                    paddingRight: 15,
                                    borderBottomWidth: 0,
                                    minWidth: 200,
                              }}
                              inputStyle={{ borderWidth: 0, marginRight: 40 }}
                              iconStyle={{ color: "#FFFFFF" }}
                              inputWrapClass="_inputWrap"
                        />
                        {
                              this.props.searchText &&
                              this.props.searchText !== "" &&
                              <Button onClick={() => this.props.search()}>
                                    Search
                              </Button>
                        }
                        {
                              this.props.hasSearched &&
                              <Button onClick={() => this.props.clearSearch()}>
                                    Clear
                              </Button>
                        }
                        {
                              this.props.isSearchBusy &&
                              <CircularProgress />
                        }
                        {
                              this.props.hasSearched === true &&
                              <div styleName="searchResults">
                                    {this.props.searchResults} results found.
                              </div>
                        }
                  </div>
                  <div styleName="header-spacer" />
                  {this.props.isBusy && <CircularProgress />}
                  <div styleName="select-group-container">
                        <Select value={this.props.filter} onChange={event => this.props.changeFilter(event.target.value)}>
                        <MenuItem value="all">All</MenuItem>
                        <MenuItem value="failing">Failing</MenuItem>
                        <MenuItem value="passing">Passing</MenuItem>
                        <MenuItem value="notRunning">Not Running</MenuItem>
                        </Select>

                        <Button onClick={() => this.props.toggleCalendar()} styleName="date-btn">
                              {
                                    this.sameDay(this.props.time.startDate, this.props.time.endDate) &&
                                    `${DateTime.formatToLocaleLongDate(this.props.time.startDate)}`
                              }
                              {
                                    !this.sameDay(this.props.time.startDate, this.props.time.endDate) &&
                                    `${DateTime.formatToLocaleLongDate(this.props.time.startDate)} - ${DateTime.formatToLocaleLongDate(this.props.time.endDate)}`
                              }
                              {
                                    this.props.calendarOpen &&
                                    <ArrowDropUp style={{fill: "rgba(0, 0, 0, 0.54)"}} />

                              }
                              {
                                    !this.props.calendarOpen &&
                                    <ArrowDropDown style={{fill: "rgba(0, 0, 0, 0.54)"}} />
                              }
                        </Button>
                  </div>
                  <div styleName="calendar-wrap" isopen={this.props.calendarOpen.toString()}>
                        <div styleName="drpContainer">
                              <DateRangePicker
                                    ranges={[this.props.time]}
                                    dragSelectionEnabled={false}
                                    showSelectionPreview={true}
                                    onChange={s => this.changeTime(s)}
                                    showPreview={true}
                                    />
                              <div styleName="drpCloseButtonContainer">
                                    <div style={{flex: 1}} />
                                    <div styleName="drpCloseButton" onClick={() => this.closeCalendar()}>Close</div>
                              </div>
                        </div>
                  </div>
            </div>
            <div styleName="content">
               <Card styleName="maincard">
                  <CardContent styleName="cardcontent">
                     <Grid container styleName="table">
                        <Grid item container>
                           <Grid item md={8} xs={8} styleName="table-header namehead centertext">
                              Category
                           </Grid>
                           <Grid item md={2} xs={2} styleName="table-header center">
                              Rules
                           </Grid>
                           <Grid item md={2} xs={2} styleName="table-header center">
                              Failed Rules
                           </Grid>
                        </Grid>
                        {
                              this.props.map !== undefined && this.props.map !== null &&
                              this.props.map._children !== undefined && this.props.map._children !== null &&
                              this.props.map._children.length === 0 &&
                              <Grid container item firstitem="true" lastitem="true" styleName="row toprow">
                                    <Grid xs={8} md={8} item>
                                          <div styleName="name">No Results</div>
                                    </Grid>
                                    <Grid md={4} item styleName="centertext" />
                              </Grid>
                        }
                        {
                              this.renderCategories(this.props.map)
                        }
                     </Grid>
                  </CardContent>
               </Card>
            </div>
         </div>
      );
   }
}

const bindAction = dispatch => {
      return {
            getRuleCategories: s => dispatch(actions.getRuleCategories(s)),
            toggleCalendar: () => dispatch(actions.toggleCalendar()),
            changeTime: time => dispatch(timeaction.updateTimeRange(time)),
            changeFilter: filter => dispatch(actions.changeFilter(filter)),
            getRulesInstsForRule: (rule, cata) => dispatch(actions.getRulesInstsForRule(rule, cata)),
            toggleOpenCategory: cata => dispatch(actions.toggleOpenCategory(cata)),
            toggleOpenRule: rule => dispatch(actions.toggleOpenRule(rule)),
            getOutcomesForRuleInst: rule => dispatch(actions.getOutcomesForRuleInst(rule)),
            setTimeout: timeoutId => dispatch(actions.setTimeout(timeoutId)),
            clearTimeout: () => dispatch(actions.clearTimeout()),

            search: () => dispatch(actions.search()),
            clearSearch: () => dispatch(actions.clearSearch()),

            navigate: (uri, data) => dispatch(router.push(uri, data)),
            goBack: () => dispatch(router.goBack())
      };
};

const mapStateToProps = state => ({
      map: state.rules.map,
      calendarOpen: state.rules.calendarOpen,
      filter: state.rules.filter,
      time: state.time.timeRange,
      rerender: state.rules.rerender,
      isBusy: state.rules.isBusy,

      currentSite: state.sitetree.currentSite,
      loadedSite: state.rules.loadedSite,
      loadedTime: state.rules.loadedTime,
   
      searchValue: state.rules.searchValue,
      searchText: state.rules.searchText,
      hasSearched: state.rules.hasSearched,
      searchResults: state.rules.searchResults,
      isSearchBusy: state.rules.isSearchBusy,

      timeoutId: state.rules.timeoutId,
});

export default connect(
   mapStateToProps,
   bindAction
)(Rules);



// WEBPACK FOOTER //
// ./src/ui/Rules/Rules/Rules.js